import { Button } from "../Button/Button";
import { Dialog, DialogActionsWrapper } from "../Dialog/Dialog";

type DeleteConfirmationProps = {
  open?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
} & (
  | { children?: React.ReactNode; description: string }
  | {
      children: React.ReactNode;
      description?: string;
    }
);

export function DeleteConfirmation({
  open,
  onConfirm,
  onCancel,
  title = "Delete",
  description,
  children,
}: DeleteConfirmationProps) {
  return (
    <Dialog
      title={title}
      description={description}
      open={open}
      onOpenChange={onCancel}
    >
      {children}
      <DialogActionsWrapper>
        <Button type="button" variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="destructive" type="button" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
}
